import React from "react";
import DailyReports from "../modules/TotalRemainingReport";

export default function TotalRemainingReportPage() {
    return <DailyReports/>
}